import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { AgentDto, CategoryDto, DynamicFormDto, DynamicPayloadDto, MemberDto } from "./dto";
import { Injectable } from "@angular/core";

@Injectable({
	providedIn: 'root'
})
export class HttpInsurancePremiumRecipientService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/insurance/premium_recipient', authService);
	}
	public getForm(type: string): Observable<DynamicFormDto> {
		return super.doGet(true, `/${type}/form`);
	}
	public get(type: string, id: number): Observable<DynamicFormDto> {
		return super.doGet(true, `/${type}/${id}`);
	}
	public create(type: string, payload: DynamicPayloadDto): Observable<DynamicFormDto> {
		return super.doPost(true, `/${type}/`, payload);
	}
	public edit(type: string, id: number, payload: DynamicPayloadDto): Observable<DynamicFormDto> {
		return super.doPost(true, `/${type}/${id}`, payload);
	}
	public getAll(type: string): Observable<CategoryDto[]> {
		return super.doGet(true, `/${type}/`);
	}
}
